export default __webpack_public_path__ + "static/media/chevron-right-gray.1eadab82.svg";